import { makeStyles } from 'tss-react/mui'
import { Theme, alpha } from '@mui/material/styles'

export const useStyles = makeStyles()((theme: Theme) => ({
  wrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  attachmentRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  attachmentChip: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    padding: `${theme.spacing(0.5)} ${theme.spacing(1.25)}`,
    borderRadius: 16,
    backgroundColor: theme.palette.boxGradientColor.gray,
    maxWidth: '100%',
  },
  attachmentName: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 12,
    lineHeight: '16px',
    color: theme.palette.labraText.tertiary,
    maxWidth: theme.spacing(22.5),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  attachmentType: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 10,
    lineHeight: '14px',
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
    color: theme.palette.labraText.description,
    flexShrink: 0,
  },
  attachmentRemove: {
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    flexShrink: 0,
    '& svg': {
      fontSize: 12,
      color: theme.palette.labraText.description,
    },
  },
  hiddenFileInput: {
    display: 'none',
  },
  inputField: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(2.125),
    borderRadius: 20,
    backgroundColor: theme.palette.text.white,
    border: `1px solid ${theme.palette.labraAIGradient.start}`,
    boxShadow: `0px 0px 10px 0px ${alpha(
      theme.palette.labraAIGradient.middle,
      0.2
    )}`,
  },
  textInput: {
    width: '100%',
    minWidth: 0,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    fontFamily: 'Inter, sans-serif',
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.tertiary,
    resize: 'none',
    padding: 0,
    maxHeight: theme.spacing(15),
    overflowY: 'auto',
    '&::placeholder': {
      color: theme.palette.labraText.description,
    },
  },
  inputFieldCompact: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  actionRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  actionRowCompact: {
    display: 'contents',
  },
  textInputCompact: {
    order: 2,
  },
  actionGroupCompact: {
    order: 1,
  },
  sendButtonCompact: {
    order: 3,
  },
  actionGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  actionButton: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: 8,
    backgroundColor: 'transparent',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '&:disabled': {
      cursor: 'default',
    },
    '&:hover:not(:disabled)': {
      backgroundColor: theme.palette.labraChat.hoverBg,
    },
    '& svg': {
      fontSize: 12,
      color: theme.palette.labraText.description,
    },
  },
}))
